<app-header></app-header>
<div class="row mt-4 ml-3 mr-1">
<h3>{{displayName}}</h3>
</div>
<div class="row mt-1 ml-1 mr-1">
  <div class="col">
    <ngx-spinner></ngx-spinner>
    <div class="cards">
      <div *ngFor="let pg of printGroups" class="card">
        <img src="{{baseUrl + pg.printGroupImageName}}" class="card-img-top" alt="{{pg.printGroupImageName}}"
          title="{{pg.printGroupImageName}}">
        <div class="card-body">
          <h5 class="card-title" style="text-align: center;">{{pg.designName}}</h5>
          <a href="nomenclature/{{productSubCategoryid}}/{{pg.printGroup1}}/false/false?name={{encodeContent(pg.designName)}}" class="stretched-link"
            title="{{pg.designName}}"></a>
        </div>
      </div>
    </div>
  </div>
</div>